import React from 'react';
import ReactECharts from 'echarts-for-react';
import type { EChartsOption } from 'echarts';

interface LineChartProps {
  data: any;
  type: 'bp' | 'bs';
}

const LineChart: React.FC<LineChartProps> = ({ data, type }) => {
  const getOption = (): EChartsOption => {
    if (type === 'bp') {
      return {
        tooltip: {
          trigger: 'axis',
          formatter: (params: any) => {
            let result = params[0].axisValue + '<br/>';
            params.forEach((param: any) => {
              result += `${param.marker} ${param.seriesName}: ${param.value} mmHg<br/>`;
            });
            return result;
          }
        },
        legend: {
          data: ['收缩压', '舒张压']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: data.dates
        },
        yAxis: {
          type: 'value',
          name: 'mmHg',
          min: 50,
          max: 200
        },
        series: [
          {
            name: '收缩压',
            type: 'line',
            data: data.systolic,
            smooth: true,
            itemStyle: { color: '#ff4d4f' },
            markLine: {
              data: [
                { yAxis: 140, name: '正常上限', lineStyle: { color: '#ff4d4f', type: 'dashed' } },
                { yAxis: 90, name: '正常下限', lineStyle: { color: '#52c41a', type: 'dashed' } }
              ]
            }
          },
          {
            name: '舒张压',
            type: 'line',
            data: data.diastolic,
            smooth: true,
            itemStyle: { color: '#1890ff' },
            markLine: {
              data: [
                { yAxis: 90, name: '正常上限', lineStyle: { color: '#ff4d4f', type: 'dashed' } },
                { yAxis: 60, name: '正常下限', lineStyle: { color: '#52c41a', type: 'dashed' } }
              ]
            }
          }
        ]
      };
    } else {
      return {
        tooltip: {
          trigger: 'axis',
          formatter: (params: any) => {
            return `${params[0].axisValue}<br/>血糖: ${params[0].value} mmol/L`;
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: data.dates
        },
        yAxis: {
          type: 'value',
          name: 'mmol/L',
          min: 2,
          max: 15
        },
        series: [
          {
            name: '血糖',
            type: 'line',
            data: data.values,
            smooth: true,
            itemStyle: { color: '#1890ff' },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0, y: 0, x2: 0, y2: 1,
                colorStops: [
                  { offset: 0, color: 'rgba(24, 144, 255, 0.3)' },
                  { offset: 1, color: 'rgba(24, 144, 255, 0.05)' }
                ]
              }
            },
            markLine: {
              data: [
                { yAxis: 6.1, name: '空腹正常上限', lineStyle: { color: '#52c41a', type: 'dashed' } },
                { yAxis: 7.8, name: '餐后正常上限', lineStyle: { color: '#faad14', type: 'dashed' } }
              ]
            }
          }
        ]
      };
    }
  };

  return (
    <ReactECharts
      option={getOption()}
      style={{ height: 400 }}
      opts={{ renderer: 'svg' }}
    />
  );
};

export default LineChart;
